export const blockIconsPlacesChildCare = (
	<span className='material-symbols-outlined'>child_care</span>
);
